import { Instagram } from "lucide-react";
import Logo, { INSTAGRAM_URL } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t hairline bg-card/40">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <Logo />
          <p className="text-sm text-silver leading-relaxed mt-5 max-w-xs">
            Colonproctologia senza tabù. Attenzione al comfort del paziente e tecniche orientate a un recupero rapido.
          </p>
        </div>
        <div className="text-sm text-silver space-y-2">
          <p className="eyebrow mb-3">Studio</p>
          <p>Via Marchese Ugo, 74 — 90141 Palermo</p>
          <a href="tel:+393333202135" data-testid="footer-cell-link" className="block hover:text-gold transition-colors w-fit">Cellulare +39 333 320 2135</a>
          <a href="tel:+390918049077" data-testid="footer-phone-link" className="block hover:text-gold transition-colors w-fit">Studio 091 804 9077</a>
          <a href="mailto:dottrobertodilorenzo@gmail.com" data-testid="footer-email-link" className="block hover:text-gold transition-colors w-fit">dottrobertodilorenzo@gmail.com</a>
        </div>
        <div className="md:text-right">
          <p className="eyebrow mb-3">Seguimi</p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 border border-white/12 rounded-full px-5 py-2.5 text-sm text-silver hover:text-gold hover:border-gold/40 transition-all"
          >
            <Instagram size={16} /> @robertodilorenzo_proctologo
          </a>
        </div>
      </div>
      <div className="border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-silver/70">
          <p>© {new Date().getFullYear()} Dott. Roberto Di Lorenzo — Tutti i diritti riservati</p>
          <p>Le informazioni su questo sito non sostituiscono un parere medico.</p>
        </div>
      </div>
    </footer>
  );
}
